﻿import React from 'react';
import {Grid} from "@mui/material";

type CardSubBodyContainerContentCenteredProps = React.ComponentPropsWithoutRef<'div'>

/**
 * MUI Grid component styled in the SecurSpace way. Used inside a SubBodyContainer to hold and style SubRowContainers
 * @param children children passed through to the internal Grid component
 * @param rest The rest of the Grid props that will be passed through to the internal Grid component
 * @constructor
 */
const CardSubBodyContainerContentCentered = ({ children, ...rest}: CardSubBodyContainerContentCenteredProps) => {
  return <Grid spacing={2} container alignItems={'center'} {...rest}>
    { children }
  </Grid>
}

export { CardSubBodyContainerContentCentered };
